import React, { useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Slider,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  AppBar,
  Toolbar,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  FormControlLabel,
  Select,
  Tab,
  Tabs,
  TextField,
  InputAdornment,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Tooltip,
} from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import FilterListIcon from "@mui/icons-material/FilterList";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { CalendarToday, Notifications, Search } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CustomDataCard, VendorappBar } from "../../../components";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CallIcon from "@mui/icons-material/Call";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import VisibilityIcon from "@mui/icons-material/Visibility";

const InventoryManagement = ({onBackScreenName}) => {
  const [priceRange, setPriceRange] = useState([500, 6500]);  // State for slider values
  const [selectedTab, setSelectedTab] = useState(0);
  // Handler for slider changes
  const handleSliderChange = (event, newValue) => {
    if (Array.isArray(newValue)) {
      setPriceRange(newValue); // Update state with new slider values
    }
  };
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const [sortOption, setSortOption] = useState("");

  const handleSortChange = (event) => {
    setSortOption(event.target.value);
  };
  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  const orderData = [
    { status: "Awaiting", count: 1148, color: "#FFA500" }, // Orange
    { status: "Received", count: 1379, color: "#008000" }, // Green
    { status: "Processed", count: 182, color: "#0000FF" }, // Blue
    { status: "Shipped", count: 265, color: "#1E90FF" }, // Dodger Blue
    { status: "Delivered", count: 792, color: "#32CD32" }, // Lime Green
    { status: "Cancelled", count: 371, color: "#FF0000" }, // Red
    { status: "Returned", count: 107, color: "#8B0000" }, // Dark Red
  ];

  const [dateRange, setDateRange] = useState("");
  const [statusFilter, setStatusFilter] = useState("All Orders");
  const [paymentFilter, setPaymentFilter] = useState("All Payment Methods");
  const [productFilter, setProductFilter] = useState("All Orders");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDateRangeChange = (event) => {
    setDateRange(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const handlePaymentChange = (event) => {
    setPaymentFilter(event.target.value);
  };

  const handleProductChange = (event) => {
    setProductFilter(event.target.value);
  };

  const filteredOrders = orderData.filter((order) => {
    // Add filtering logic based on dateRange, statusFilter, paymentFilter, and productFilter
    return true; // For now, show all orders
  });
  const card = [
    // Male Clothes
    {
      id: 1,
      productname: "Casual T-Shirt",
      description: "Comfortable cotton t-shirt available in various sizes.",
      price: "$19.99",
      sku: 123,
      holescount: 100,
      imagepath:
        "https://via.placeholder.com/300x300.png?text=Leather%20Jacket",
    },
    {
      id: 2,
      productname: "Denim Jeans",
      description: "Classic blue denim jeans with a slim fit.",
      price: "$49.99",
      sku: 456,
      holescount: 50,
      imagepath:
        "https://via.placeholder.com/300x300.png?text=Leather%20Jacket",
    },
    {
      id: 3,
      productname: "Leather Jacket",
      description: "Stylish leather jacket for an edgy look.",
      price: "$149.99",
      sku: 789,
      holescount: 25,
      imagepath:
        "https://via.placeholder.com/300x300.png?text=Leather%20Jacket",
    },
    {
      id: 4,
      productname: "Sneakers",
      description: "Comfortable sneakers for everyday wear.",
      price: "$69.99",
      sku: 101,
      holescount: 80,
      imagepath: "https://via.placeholder.com/300x300.png?text=Sneakers",
    },
    {
      id: 5,
      productname: "Formal Shirt",
      description: "Classic white formal shirt made from premium cotton.",
      price: "$29.99",
      sku: 303,
      holescount: 120,
      imagepath: "https://via.placeholder.com/300x300.png?text=Formal%20Shirt",
    },
    {
      id: 6,
      productname: "Slim Fit Suit",
      description: "Elegant slim fit suit perfect for formal occasions.",
      price: "$199.99",
      sku: 404,
      holescount: 40,
      imagepath:
        "https://via.placeholder.com/300x300.png?text=Slim%20Fit%20Suit",
    },
    {
      id: 7,
      productname: "Polo Shirt",
      description: "Casual polo shirt available in various colors.",
      price: "$25.99",
      sku: 505,
      holescount: 90,
      imagepath: "https://via.placeholder.com/300x300.png?text=Polo%20Shirt",
    },
    {
      id: 8,
      productname: "Cargo Pants",
      description: "Durable cargo pants for outdoor activities.",
      price: "$45.99",
      sku: 606,
      holescount: 60,
      imagepath: "https://via.placeholder.com/300x300.png?text=Cargo%20Pants",
    },
    {
      id: 9,
      productname: "Winter Coat",
      description: "Warm and stylish winter coat for cold weather.",
      price: "$99.99",
      sku: 707,
      holescount: 30,
      imagepath: "https://via.placeholder.com/300x300.png?text=Winter%20Coat",
    },
    {
      id: 10,
      productname: "Track Suit",
      description: "Lightweight tracksuit for sports and fitness.",
      price: "$59.99",
      sku: 808,
      holescount: 70,
      imagepath: "https://via.placeholder.com/300x300.png?text=Track%20Suit",
    },

    // Female Clothes
    {
      id: 11,
      productname: "Summer Dress",
      description: "Light and breezy summer dress in floral prints.",
      price: "$39.99",
      sku: 202,
      holescount: 60,
      imagepath: "https://via.placeholder.com/300x300.png?text=Summer%20Dress",
    },
    {
      id: 12,
      productname: "Evening Gown",
      description: "Elegant evening gown for formal occasions.",
      price: "$149.99",
      sku: 909,
      holescount: 15,
      imagepath: "https://via.placeholder.com/300x300.png?text=Evening%20Gown",
    },
    {
      id: 13,
      productname: "Leather Boots",
      description: "Chic leather boots perfect for fall and winter.",
      price: "$89.99",
      sku: 10,
      holescount: 45,
      imagepath: "https://via.placeholder.com/300x300.png?text=Leather%20Boots",
    },
    {
      id: 14,
      productname: "Maxi Skirt",
      description: "Flowy maxi skirt with a bohemian vibe.",
      price: "$29.99",
      sku: 111,
      holescount: 55,
      imagepath: "https://via.placeholder.com/300x300.png?text=Maxi%20Skirt",
    },
    {
      id: 15,
      productname: "Blouse",
      description: "Elegant silk blouse perfect for work and casual settings.",
      price: "$35.99",
      sku: 222,
      holescount: 85,
      imagepath: "https://via.placeholder.com/300x300.png?text=Blouse",
    },
    {
      id: 16,
      productname: "Cardigan",
      description: "Cozy cardigan for layering during cooler months.",
      price: "$49.99",
      sku: 333,
      holescount: 65,
      imagepath: "https://via.placeholder.com/300x300.png?text=Cardigan",
    },
    {
      id: 17,
      productname: "Skinny Jeans",
      description: "Stretchy skinny jeans with a flattering fit.",
      price: "$59.99",
      sku: 444,
      holescount: 70,
      imagepath: "https://via.placeholder.com/300x300.png?text=Skinny%20Jeans",
    },
    {
      id: 18,
      productname: "Peacoat",
      description: "Stylish peacoat for a polished winter look.",
      price: "$119.99",
      sku: 555,
      holescount: 40,
      imagepath: "https://via.placeholder.com/300x300.png?text=Peacoat",
    },
    {
      id: 19,
      productname: "High Heels",
      description: "Elegant high heels for formal and evening wear.",
      price: "$79.99",
      sku: 666,
      holescount: 35,
      imagepath: "https://via.placeholder.com/300x300.png?text=High%20Heels",
    },
    {
      id: 20,
      productname: "Summer Hat",
      description: "Wide-brimmed hat for sun protection and style.",
      price: "$19.99",
      sku: 777,
      holescount: 120,
      imagepath: "https://via.placeholder.com/300x300.png?text=Summer%20Hat",
    },
  ];

  function createData(
    orderId,
    userName,
    sellers,
    total,
    dCharge,
    walletUsed,
    promoDisc,
    finalTotal,
    paymentMethod,
    orderDate
  ) {
    return {
      orderId,
      userName,
      sellers,
      total,
      dCharge,
      walletUsed,
      promoDisc,
      finalTotal,
      paymentMethod,
      orderDate,
    };
  }

  const rows = [
    createData(
      "11785",
      "Support User",
      "seller name",
      "130008",
      "0",
      "0",
      "0",
      "130008",
      "bank transfer",
      "10-10-2024"
    ),
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        p: 3,
        bgcolor: "#EEF2FF",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* <AppBar
          position="static"
          elevation={0}
          sx={{
            borderBottom: "1px solid #ddd",
            mb: 2,
            backgroundColor: "white",
            color: "black",
            borderRadius: "20px",
          }}
        >
          <Toolbar>
            <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
              Inventory Management
            </Typography>
            <IconButton>
              <CalendarToday />
            </IconButton>
            <Typography variant="body1" sx={{ mx: 2 }}>
              28 Dec, 2024
            </Typography>
            <IconButton>
              <Notifications />
            </IconButton>
            <Avatar alt="Gn" src="/profile.webp" />
          </Toolbar>
        </AppBar> */}
        <VendorappBar title={" Inventory Management"} onBackScreenName={handleScreeName}/>
      </Box>

      {/* Tabs Section */}
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        sx={{
          // backgroundColor: "white",
          borderBottom: "1px solid #ddd",
          color: "black",
        }}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="Sales Dashboard" />
        <Tab label="Products list" />
        <Tab label="Thershold Products" />
      </Tabs>
      {/* Content */}
      {selectedTab === 0 && (
        <>
          <Box>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
              Search by Product name
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <TextField
                placeholder="Search"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
                size="small"
                sx={{ maxWidth: 300 }}
              />
            </Box>
          </Box>

          <Card
            sx={{
              mt: 0,
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <CardContent>
              <Box sx={{ p: 0 }}>
                <Typography variant="h4" gutterBottom>
                  Manage Orders
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Order Outlines
                    </Typography>
                    <Grid container spacing={2}>
                      {filteredOrders.map((order) => (
                        <Grid item xs={12} sm={6} md={4} key={order.status}>
                          <Card
                            style={{
                              backgroundColor: order.color, // Set background color dynamically
                              color: "#FFFFFF", // Optional: Ensure text contrast with light text
                              borderRadius: "16px",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            <CardContent>
                              <Typography variant="h5">
                                {order.count}
                              </Typography>
                              <Typography variant="body2">
                                {order.status}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} alignItems="center" p={2}>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        label="Date Range"
                        value={dateRange}
                        onChange={handleDateRangeChange}
                        fullWidth
                        margin="normal"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        select
                        label="Order Status"
                        value={statusFilter}
                        onChange={handleStatusChange}
                        fullWidth
                        margin="normal"
                      >
                        <option value="All Orders">All Orders</option>
                        {orderData.map((order) => (
                          <option key={order.status} value={order.status}>
                            {order.status}
                          </option>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        select
                        label="Payment Method"
                        value={paymentFilter}
                        onChange={handlePaymentChange}
                        fullWidth
                        margin="normal"
                      >
                        <option value="All Payment Methods">
                          All Payment Methods
                        </option>
                        {/* Add payment method options here */}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        select
                        label="Product"
                        value={productFilter}
                        onChange={handleProductChange}
                        fullWidth
                        margin="normal"
                      >
                        <option value="All Products">All Products</option>
                        {/* Add product options here */}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={() => {
                          /* Add filter logic */
                        }}
                      >
                        Filter
                      </Button>
                    </Grid>
                  </Grid>

                  <TableContainer
                    component={Paper}
                    elevation={3}
                    sx={{ margin: "20px 0" }}
                  >
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 2,
                          p: 2,
                        }}
                      >
                        <TextField
                          placeholder="Search"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Search />
                              </InputAdornment>
                            ),
                          }}
                          variant="outlined"
                          size="small"
                          sx={{ maxWidth: 300 }}
                        />
                      </Box>
                    </Box>

                    <Table
                      sx={{ minWidth: 650, borderCollapse: "collapse" }}
                      aria-label="enhanced table"
                    >
                      {/* Table Header */}
                      <TableHead>
                        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                          <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                            <strong>Order ID</strong>
                          </TableCell>
                          <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                            <strong>User Name</strong>
                          </TableCell>
                          <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                            <strong>Sellers</strong>
                          </TableCell>
                          <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                            <strong>Total ($)</strong>
                          </TableCell>
                          <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                            <strong>D. Charge</strong>
                          </TableCell>
                          <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                            <strong>Wallet Used ($)</strong>
                          </TableCell>
                          <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                            <strong>Promo Disc. ($)</strong>
                          </TableCell>
                          <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                            <strong>Final Total ($)</strong>
                          </TableCell>
                          <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                            <strong>Payment Method</strong>
                          </TableCell>
                          <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                            <strong>Order Date</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Actions</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      {/* Table Body */}
                      <TableBody>
                        {rows
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row) => (
                            <TableRow
                              key={row.orderId}
                              sx={{
                                "&:nth-of-type(odd)": {
                                  backgroundColor: "#f9f9f9",
                                },
                                "&:hover": { backgroundColor: "#eaeaea" },
                              }}
                            >
                              <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                                {row.orderId}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                                {row.userName}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                                {row.sellers}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                                {row.total}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                                {row.dCharge}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                                {row.walletUsed}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                                {row.promoDisc}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                                {row.finalTotal}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                                {row.paymentMethod}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                                {row.orderDate}
                              </TableCell>
                              <TableCell>
                                <Tooltip title="View">
                                  <IconButton aria-label="view">
                                    <VisibilityIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Edit">
                                  <IconButton aria-label="edit">
                                    <EditIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete">
                                  <IconButton aria-label="delete">
                                    <DeleteIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Call">
                                  <IconButton aria-label="call">
                                    <CallIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Location">
                                  <IconButton aria-label="location">
                                    <LocationOnIcon />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>

                    {/* Pagination */}
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={rows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </>
      )}

      {selectedTab === 1 && (
        <>
          <Box sx={{ display: "flex" }}>
            {/* Sidebar */}
            <Box
              sx={{
                width: "20%",
                backgroundColor: "#f9f9f9",
                p: 2,
                borderRadius: 2,
              }}
            >
              {/* Category Accordion */}
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" fontWeight="bold">
                    Category
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box>
                    <FormControlLabel
                      control={<Checkbox />}
                      label={<Typography variant="body2">Mens</Typography>}
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label={<Typography variant="body2">Womens</Typography>}
                    />
                  </Box>
                </AccordionDetails>
              </Accordion>

              {/* Brands Accordion */}
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" fontWeight="bold">
                    Brands
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box>
                    <FormControlLabel
                      control={<Checkbox />}
                      label={<Typography variant="body2">Puma</Typography>}
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label={<Typography variant="body2">Nike</Typography>}
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label={<Typography variant="body2">HRX</Typography>}
                    />
                  </Box>
                </AccordionDetails>
              </Accordion>

              {/* Price Accordion */}
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" fontWeight="bold">
                    Price
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box sx={{ width: "100%" }}>
                    <Slider
                      value={priceRange}
                      onChange={handleSliderChange}
                      valueLabelDisplay="auto"
                      min={750}
                      max={7500}
                      sx={{ width: "100%" }}
                    />
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="body2">
                        Price Range: ₹{priceRange[0]} - ₹{priceRange[1]}
                      </Typography>
                    </Box>
                  </Box>
                </AccordionDetails>
              </Accordion>

              {/* Deals & Discounts Accordion */}
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" fontWeight="bold">
                    Deals & Discounts
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {/* Add deals selection, for example: */}
                  <FormControlLabel
                    control={<Checkbox />}
                    label={<Typography variant="body2">20% Off</Typography>}
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    label={<Typography variant="body2">Buy 1 Get 1</Typography>}
                  />
                </AccordionDetails>
              </Accordion>
            </Box>

            {/* Main Section */}
            <Box sx={{ flexGrow: 1 }}>
              {/* Sort and Filter */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Select
                    value={sortOption}
                    onChange={handleSortChange}
                    displayEmpty
                    fullWidth
                    sx={{ mt: 1 }}
                  >
                    <MenuItem value="">
                      <em>Sort by</em>
                    </MenuItem>
                    <MenuItem value="allModels">All Models</MenuItem>
                    <MenuItem value="quantities">Quantities</MenuItem>
                    <MenuItem value="price">Price</MenuItem>
                    <MenuItem value="offerPrice">Offer Price</MenuItem>
                  </Select>
                </Box>
              </Box>

              {/* Products Grid */}

              {/* <Grid container spacing={2} sx={{ mt: 2 }}>
              {Array.from({ length: 12 }).map((_, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card>
                    <Box sx={{ height: 150, backgroundColor: "#e0e0e0" }} />
                    <CardContent>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Lymio Men Regular Fit T-Shirt for Men (Black)
                      </Typography>
                      <Typography variant="h6" color="text.secondary">
                        $744
                      </Typography>
                      <Typography variant="body2">
                        A relaxed, comfortable T-shirt with a crew neck, ideal for
                        casual wear.
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 2,
                        }}
                      >
                        <Box>
                          <Typography variant="body2">Sales</Typography>
                          <Typography variant="body1" fontWeight="bold">
                            1269
                          </Typography>
                        </Box>
                        <Box>
                          <Typography variant="body2">
                            Remaining Products
                          </Typography>
                          <Typography variant="body1" fontWeight="bold">
                            1209
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid> */}

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2,  1fr)", // Cards will resize responsively
                  gap: "0px",
                  justifyContent: "center",
                  padding: "20px",
                }}
              >
                {card.map((data) => (
                  <CustomDataCard
                    key={data.id}
                    title={data.productname}
                    summary={data.description}
                    price={data.price}
                    sales={data.sku}
                    remaining={data.holescount}
                    image={data.imagepath}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        </>
      )}

      {selectedTab === 2 && (
        <>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(3,  1fr)", // Cards will resize responsively
              gap: "0px",
              justifyContent: "center",
              padding: "20px",
            }}
          >
            {card.map((data) => (
              <CustomDataCard
                key={data.id}
                title={data.productname}
                summary={data.description}
                price={data.price}
                sales={data.sku}
                remaining={data.holescount}
                image={data.imagepath}
              />
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};

export default InventoryManagement;
